import { render, staticRenderFns } from "./PCFooter.vue?vue&type=template&id=a39eb24e&scoped=true&"
import script from "./PCFooter.vue?vue&type=script&lang=js&"
export * from "./PCFooter.vue?vue&type=script&lang=js&"
import style0 from "./PCFooter.vue?vue&type=style&index=0&id=a39eb24e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39eb24e",
  null
  
)

export default component.exports